import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { ApplicationArgs, ApplicationVariables } from './queryVariables/application';
export class ApplicationResource extends EntityResource {
    constructor() {
        super({ entityName: 'application' });
        this.getFields = {
            id: true,
            state: true,
            type: true,
            firstName: true,
            lastName: true,
            birthDate: true,
            images: true,
            woj: true,
            pow: true,
            gmi: true,
            terc: true,
            city: true,
            simc: true,
            street: true,
            homeNumber: true,
            physicalAttachments: true,
            localNumber: true,
            email: true,
            phoneNumber: true,
            ulic: true,
            postalCode: true,
            created: true,
            modified: true,
            acceptDate: true,
            physical: true,
            rejectDate: true,
            reason: true,
            groups: true,
            collectionPoint: {
                id: true,
                name: true,
                city: true,
                street: true,
                homeNumber: true,
                localNumber: true,
                postalCode: true
            },
            profile: {
                id: true,
                userId: true
            },
            decisionMakerProfile: {
                firstName: true,
                lastName: true,
                userId: true
            },
            mediaObjects: {
                id: true,
                title: true
            },
            card: {
                endDate: true
            }
        };
        this.listFields = {
            id: true,
            state: true,
            firstName: true,
            lastName: true,
            birthDate: true,
            created: true,
            city: true,
            street: true,
            type: true,
            homeNumber: true,
            localNumber: true,
            reason: true,
            physical: true,
            postalCode: true,
            collectionPoint: {
                id: true,
                name: true
            }
        };
        this.addVariables = ApplicationVariables;
        this.addArgs = ApplicationArgs;
        this.listVariables = { filters: 'ApplicationFilters' };
        this.updateVariables = { id: 'Int!', state: 'String!', reason: 'String', groups: 'JSON' };
        this.updateArgs = {
            id: new VariableType('id'),
            state: new VariableType('state'),
            reason: new VariableType('reason'),
            groups: new VariableType('groups')
        };
    }
    /**
     * Ustawianie statusu wniosku
     *
     * @param {number} id
     * @param {number} state
     * @param {string} [reason]
     * @returns {Promise<void>}
     * @memberof ApplicationResource
     */
    async setState(id, state, reason) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { id: 'Int!', state: 'Int!', reason: 'String' },
                applicationSetState: {
                    __args: {
                        id: new VariableType('id'),
                        state: new VariableType('state'),
                        reason: new VariableType('reason')
                    }
                }
            }
        });
        return this.mutation({ mutation, variables: { id, state, reason } }, 'applicationSetState');
    }
    /**
     * Usuwa plik z wniosku
     *
     * @param {{ id: number; mediaId: number }} variables
     * @returns {Promise<boolean>}
     * @memberof ApplicationResource
     */
    async removeMedia(variables) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { id: 'Int!', mediaId: 'Int!' },
                applicationRemoveMedia: {
                    __args: {
                        id: new VariableType('id'),
                        mediaId: new VariableType('mediaId')
                    }
                }
            }
        });
        return this.mutation({ mutation, variables }, 'applicationRemoveMedia');
    }
}
export const applicationResource = new ApplicationResource();
//# sourceMappingURL=application.resource.js.map